export type DashboardMetaData = {
    category: string;
    dashboardId: string;
    dashboardName: string;
    description: string;
    dataSources: string[];
    techDocs: string;
};

export enum DashboardCategory {
    APPLICATION_PLATFORM_COMPLIANCE = 'Application and Platform Compliance Dashboards',
    TECH_DEBT = 'Tech Debt Dashboards',
    ENGINEERING_PROCESS = 'Engineering Process Dashboards'
}
